import { BasePublisher, JapanesePublisherLocalization } from '@oneappexchange/oaf-schema';
import { BadgeKey } from '~/modules/helpers/badgeHelper';
import { getUserLanguage } from '~/modules/helpers/languageHelper';
import { ListingResponse } from '~/modules/services/listing_service';
import { generateMediaUrl } from '~/modules/utilities/asset_utils';
import { JAPANESE_LANGUAGE_CODE } from '~/modules/utilities/language_utils';
import { selectExtensionListing } from '~/modules/utilities/listing_utils';
import { logger } from '../utilities/logger';

/**
 *
 * @param listing
 * @returns  array with social impact features labels to map from localization file based on direct oAF field mappings
 */
export function selectSocialImpactFeatures(listingResponse: ListingResponse) {
    const listing = selectExtensionListing(listingResponse);

    const socialImpactFeatures: BadgeKey[] = [];

    // Add supported features badge text from mapping
    if (listing?.isPledge1Percent) {
        socialImpactFeatures.push('isPledge1Percent');
    }
    if (listing?.isDiverseOwnedBusiness) {
        socialImpactFeatures.push('isDiverseOwnedBusiness');
    }

    return socialImpactFeatures;
}

export function getListingPublisher(
    listing?: ListingResponse | null,
): BasePublisher | JapanesePublisherLocalization | null {
    if (getUserLanguage() === JAPANESE_LANGUAGE_CODE) {
        return listing?.publisher?.marketplaceLocalization?.jp ?? listing?.publisher ?? null;
    }
    return listing?.publisher ?? null;
}

export function getListingLogo(listing?: ListingResponse | null): string {
    const listingWithLogos = listing as ListingResponse & { 'listing/plugins/LogoSet': { Logo?: string } };
    const logo = generateMediaUrl(listingWithLogos?.['listing/plugins/LogoSet']?.Logo ?? '');
    if (!logo) {
        logger.error(`Failed to find a Logo for listing ${listing!.id}`);
    }
    return logo;
}

export function getCategoryTagsForTiles(listing: ListingResponse): AnyObject[] {
    return selectExtensionListing(listing)?.listingCategories?.map((name) => ({ name })) ?? [];
}
